import React from 'react';
import TagInput from '../inputs/TagInput';
import AutocompleteInput from '../inputs/AutocompleteInput';
import MultiSelectGrid from '../inputs/MultiSelectGrid';
import { EMPLOYEE_SIZE_OPTIONS, REVENUE_OPTIONS, BUSINESS_MODEL_OPTIONS } from '../../../constants/peakyLeadsOptions';
import { INDUSTRIES } from '../../../constants/autocompleteData';

const CompanyFilters = ({ filters, onFilterChange }) => {
  return (
    <>
      <MultiSelectGrid
        label="Employee Size"
        options={EMPLOYEE_SIZE_OPTIONS}
        value={filters.company_employee_size}
        onChange={(value) => onFilterChange('company_employee_size', value)}
        minWidth="140px"
        hint="Select one or more employee size ranges"
      />

      <AutocompleteInput
        label="Industry"
        value={filters.industry}
        onChange={(value) => onFilterChange('industry', value)}
        placeholder="Type to search industries..."
        suggestions={INDUSTRIES}
        hint="Add industry categories"
      />

      <TagInput
        label="Industry Keywords"
        value={filters.industry_keywords}
        onChange={(value) => onFilterChange('industry_keywords', value)}
        placeholder="e.g., AI, Machine Learning (Press Enter to add)"
        maxTags={100}
        hint="Add up to 100 industry-related keywords"
      />

      <MultiSelectGrid
        label="Revenue Range"
        options={REVENUE_OPTIONS}
        value={filters.revenue}
        onChange={(value) => onFilterChange('revenue', value)}
        minWidth="140px"
        hint="Select one or more revenue ranges"
      />

      <MultiSelectGrid
        label="Business Model"
        options={BUSINESS_MODEL_OPTIONS}
        value={filters.business_model}
        onChange={(value) => onFilterChange('business_model', value)}
        minWidth="140px"
        hint="Select one or more business models"
      />

      <TagInput
        label="Company Domains"
        value={filters.company_domain}
        onChange={(value) => onFilterChange('company_domain', value)}
        placeholder="e.g., acme.com, example.io (Press Enter to add)"
        maxTags={10}
        hint="Add up to 10 company website domains"
      />
    </>
  );
};

export default CompanyFilters;
